import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'uppercaseFirst',
    standalone: true,
})
export class UppercaseFirstPipe implements PipeTransform {
    transform(value: unknown): string {
        if (typeof value === 'string' && 0 < value.length) {
            return value[0].toLocaleUpperCase() + value.substr(1);
        } else {
            return this.isTruthy(value) ? value.toString() : '';
        }
    }

    private isTruthy(value: unknown): value is object {
        return value != null;
    }
}
